import get from 'get-value';
import {marketingWebsocketCommands} from '../../constants/marketingWebsocketCommands';

export const marketingDealer = (state = {
    isLoadingDealer: false,
    dealers: [],
    correlationId: null,
}, action) => {
    switch (action.type) {
        case marketingWebsocketCommands.MARKETING_DEALERS_GET: {
            return Object.assign({}, state, {isLoadingDealer: true});
        }
        case marketingWebsocketCommands.MARKETING_DEALERS_SEND: {
            const dealers = get(action, 'payload.dealers', {default: []});
            return Object.assign({}, state, {
                isLoadingDealer: false,
                dealers,
            });
        }
        case marketingWebsocketCommands.MARKETING_DEALERS_SEND_ERROR: {
            return Object.assign({}, state, {isLoadingDealer: false});
        }
        default:
            return state;
    }
};
